import { Description, Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { Loader2, X } from "lucide-react";
import { primaryButtonClass, secondaryButtonClass } from "./schedulingControlStyles";

export default function SetupEntityDialog({ title, description, busy, error, onClose, saveLabel, children }) {
  return <Dialog open onClose={() => { if (!busy) onClose(); }} className="relative z-50">
    <div className="fixed inset-0 bg-slate-900/40" aria-hidden="true" />
    <div className="fixed inset-0 overflow-y-auto p-4 sm:p-6">
      <div className="flex min-h-full items-center justify-center">
        <DialogPanel className="w-full max-w-lg rounded-lg border border-slate-200 bg-white shadow-xl" aria-busy={busy}>
          <div className="flex items-start justify-between gap-4 border-b border-slate-200 p-5">
            <div><DialogTitle className="text-lg font-semibold text-slate-900">{title}</DialogTitle><Description className="mt-1 text-sm text-slate-500">{description}</Description></div>
            <button type="button" aria-label={`Close ${title.toLowerCase()}`} disabled={busy} onClick={onClose} className={`${secondaryButtonClass} w-9 px-0`}><X size={16} aria-hidden="true" /></button>
          </div>
          <div className="space-y-4 p-5">
            {error && <p role="alert" className="rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-800">{error}</p>}
            {children}
          </div>
          <div className="flex justify-end gap-3 border-t border-slate-200 p-4">
            <button type="button" disabled={busy} onClick={onClose} className={secondaryButtonClass}>Cancel</button>
            <button type="submit" form="setup-entity-form" disabled={busy} className={primaryButtonClass}>{busy && <Loader2 size={16} className="animate-spin" aria-hidden="true" />}{busy ? "Saving…" : saveLabel}</button>
          </div>
        </DialogPanel>
      </div>
    </div>
  </Dialog>;
}
